import { client } from '../../..'
import { ACCEPT_REQUESTED_MEETING } from '../MeetingMutations'
import { MeetingInviteProps } from './useInviteMeeting'
import { AcceptRequestedMeetingMutation, AcceptRequestedMeetingMutationVariables } from '../../../types'
import { GET_MEETING_REQUESTS_BY_REVIEWER, MEETINGS_AND_REQUESTS_BY_REPLYER } from '../MeetingRequestQueries'
import { MEETINGS_BY_MANAGER } from '../meeting.graphql'
import { FetchResult, MaybeMasked } from '@apollo/client'

export default (): {
  acceptMeetingRequest: (
    requestedMeetingId: number,
    meetingInputData: MeetingInviteProps,
  ) => Promise<FetchResult<AcceptRequestedMeetingMutation>>
} => {
  const acceptMeetingRequest = (
    requestedMeetingId: number,
    meetingInputData: MeetingInviteProps,
  ): Promise<FetchResult<MaybeMasked<AcceptRequestedMeetingMutation>>> => {
    return client.mutate<AcceptRequestedMeetingMutation, AcceptRequestedMeetingMutationVariables>({
      mutation: ACCEPT_REQUESTED_MEETING,
      variables: {
        requestedMeetingId: requestedMeetingId,
        meetingInput: meetingInputData,
      },
      refetchQueries: [
        {
          query: GET_MEETING_REQUESTS_BY_REVIEWER, // Requested Meetings Tab in Meeting View
          variables: {
            reviewerId: meetingInputData.reviewerId,
          },
        },
        {
          query: MEETINGS_AND_REQUESTS_BY_REPLYER, // Meetings Tab in Public Profile
          variables: {
            replyerId: meetingInputData.employeeId,
          },
        },
        {
          query: MEETINGS_BY_MANAGER,
          variables: { managerId: meetingInputData.reviewerId },
        },
      ],
      awaitRefetchQueries: true,
    })
  }

  return { acceptMeetingRequest }
}
